import { motion } from 'framer-motion';
import { Box } from '@mui/material';

import { varWrapEnter } from './variants';

interface Props {
    open: boolean,
};

const MotionContainer: React.FC<Props> = ({ open, children, ...other }) => {
    return (
        <Box
            component={motion.div}
            initial={false}
            animate={open ? 'animate' : 'exit'}
            variants={varWrapEnter}
            {...other}
        >
            {children}
        </Box>
    );
}

export default MotionContainer;